import SubstanceJson from './SubstanceJson.js';

export default class StructureMeta {
	/**
	 * @param {string?} structureId
	 * @param {string} alias
	 * @param {string?} mf
	 * @param {number?} emw
	 * @param {string?} injectionName
	 * @param {string?} structureSvgPath
	 * @param {string?} sourceSubstanceId
	 */
	constructor({alias, mf, emw, injectionName, structureId, structureSvgPath, sourceSubstanceId}) {
		this.id = structureId;
		this.alias = alias;
		this.mf = mf;
		this.emw = emw;
		this.injectionName = injectionName;
		this.structureSvgPath = structureSvgPath;
		this.sourceSubstanceId = sourceSubstanceId;
	}

	static parseServerJson(json) {
		return new StructureMeta(json);
	}

	static fromAnalyte(analyte) {
		return new StructureMeta({
			alias: analyte.alias,
			mf: analyte.mf,
			emw: analyte.emw,
			structureSvgPath: analyte.structureSvgPath,
			sourceSubstanceId: analyte.id
		});
	}

	isImported() {
		return !!this.sourceSubstanceId;
	}

	toSubstanceJson() {
		return new SubstanceJson({
			structureId: this.id,
			alias: this.alias,
			mf: this.mf,
			emw: this.emw
		});
	}
}
